module.exports = __webpack_public_path__ + "8656c26f6504e88d486866e59799493a.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/dispatcher.png
 ** module id = 1057
 ** module chunks = 0
 **/